<template>
  <div class="container">
    <GmapMap :center="{ lat: center.lat, lng: center.long }" :zoom="zoom" style="width: 100%; height: 100%" :options="{
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: false,
      gestureHandling: 'greedy'
    }">
      <GmapMarker :position="{ lat: location.lat, lng: location.long }" :clickable="false" :draggable="false" />
      <GmapCircle v-for="area in area_list" :key="area.area_id" :center="{
        lat: parseFloat(area.area_lat),
        lng: parseFloat(area.area_long)
      }" :radius="parseInt(area.area_limit)" :visible="true" :options="{
  fillColor: area.rad_color,
  fillOpacity: 0.3,
  strokeWeight: 0
}"></GmapCircle>
    </GmapMap>
    <!-- top container -->
    <div class="top-container">
      <div class="profile-box">
        <div class="profile-image">
          <img :src="user.image || '/static/img/nouser.jpg'" onerror="this.src='/static/img/nouser.jpg'" />
        </div>
        <div class="profile-detail">
          <div class="fullname">{{ user.fullname }}</div>
          <small class="position text-mute">ตำแหน่ง: {{ user.position }}</small>
        </div>
      </div>
    </div>
    <!-- bottom container -->
    <div class="bottom-container">
      <div class="action-box">
        <button class="btn btn-success action-btn m-r-5" @click="reLoad()">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
            <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
          </svg>
        </button>
        <button class="btn btn-success action-btn m-r-5" @click="reCenter()">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <circle cx="12" cy="12" r="3" />
            <circle cx="12" cy="12" r="8" />
            <line x1="12" y1="2" x2="12" y2="4" />
            <line x1="12" y1="20" x2="12" y2="22" />
            <line x1="20" y1="12" x2="22" y2="12" />
            <line x1="2" y1="12" x2="4" y2="12" />
          </svg>
        </button>
        <button class="btn btn-success action-btn" @click="cardGenerator()" :disabled="user.card_id === ''">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-id" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
            <rect x="3" y="4" width="18" height="16" rx="3"></rect>
            <circle cx="9" cy="10" r="2"></circle>
            <line x1="15" y1="8" x2="17" y2="8"></line>
            <line x1="15" y1="12" x2="17" y2="12"></line>
            <line x1="7" y1="16" x2="17" y2="16"></line>
          </svg>
        </button>
      </div>
      <div class="detail-box">
        <div class="location-box">
          <div class="location-show">
            <small class="text-mute">จุดลงเวลา</small>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="16" height="16" viewBox="0 0 30 30" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="12" cy="11" r="3" />
                <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
              </svg>
              {{ area_use_name }}
            </div>
          </div>
          <div class="location-switch text-right">
            <small class="text-mute" style="text-align: right">ตัวเลือกจุดลงเวลา</small>
            <div @click="switchType()">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style="margin-top: -5px !important" v-if="type === 1">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <rect x="4" y="4" width="16" height="16" rx="2" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style="margin-top: -5px !important" v-if="type === 2">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <path d="M9 12l2 2l4 -4" />
              </svg>
              ปฏิบัติงานที่บ้าน
            </div>
          </div>
        </div>
        <div class="">
          <small class="text-mute">ลงเวลาล่าสุด</small>
          <ul class="checkin-list">
            <li class="" v-for="(row, index) in recent_checkin" :key="index">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="16" height="16" viewBox="0 0 30 30" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="12" cy="12" r="9" />
                <polyline points="12 7 12 12 15 15" />
              </svg>
              {{ row.datetime }} - {{ row.area_name }}
            </li>
          </ul>
        </div>
      </div>
      <div class="checkin-box">
        <button class="btn btn-success btn-lg w-100" :disabled="is_allow === false || $store.state.is_loading === true" @click="checkIn()">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style="margin-top: -6px !important">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697" />
            <path d="M18 14v4h4" />
            <path d="M18 11v-4a2 2 0 0 0 -2 -2h-2" />
            <rect x="8" y="3" width="6" height="4" rx="2" />
            <circle cx="18" cy="18" r="4" />
            <path d="M8 11h4" />
            <path d="M8 15h3" />
          </svg>
          {{ text_checkin }}
        </button>
      </div>
    </div>
    <modal name="card_modal" :resizable="true" width="95%" height="auto">
      <div class="card_container">
        <div class="card_title">
          <h4>บัตรยืนยันตัวตน RMUTL Account</h4>
        </div>
        <div class="card_body m-b-10">
          <div class="m-b-5">
            <h5>{{ user.fullname }}</h5>
            <h5>RMUTL ID {{ user.card_id }}</h5>
          </div>
          <div class="m-b-5">
            <barcodeView :id_card="user.card_id" />
          </div>
        </div>
        <div class="card_footer">
          <button class="btn btn-outline-secondary btn-lg w-100" @click="$modal.hide('card_modal')">
            ปิดหน้านี้
          </button>
        </div>
      </div>
    </modal>
    <modal name="alert_modal" :resizable="true" width="95%" height="auto">
      <div class="card_container">
        <div class="card_title">
          <h4>การแจ้งเตือน</h4>
        </div>
        <div class="card_body m-b-10">
          <div class="m-b-5 text-start">
            <div>&emsp;เว็บไซต์ระบบ CheckIn RMUTL บนระบบปฏิบัติการ Android จะปิดให้บริการหลังจากวันที่ 30 กันยายน 2566</div>
            <div>&emsp;ท่านสามารถใช้งานระบบ CheckIn RMUTL ผ่านทางแอพพลิเคชั่น RMUTL CheckIn สามารถดาวน์โหลดได้ที่ลิงค์ด้านล่าง</div>
          </div>
        </div>
        <div class="card_footer">
          <!-- <button class="btn btn-outline-secondary btn-lg w-100" @click="$modal.hide('alert_modal')">
            รับทราบ
          </button> -->
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import jwt_decode from 'jwt-decode'
import apis from '../models/apis'
import Swal from 'sweetalert2'
import barcodeView from '../components/barcodeView'

export default {
  name: 'checkin',
  components: {
    barcodeView
  },
  data () {
    return {
      loop_location: '',
      area_list: [],
      area_use: [],
      area_use_id: 99,
      area_use_name: '---',
      recent_checkin: [],
      text_checkin: 'ลงเวลาปฏิบัติงาน',
      zoom: 15,
      location: {
        lat: 0,
        long: 0
      },
      center: {
        lat: 0,
        long: 0
      },
      type: 1,
      is_allow: false,
      is_real_location: false,
      user: {
        instructor_id: '',
        campus_id: '',
        fingerprint_id: '',
        fullname: '---',
        position: '---',
        image: '/static/img/nouser.jpg',
        wfh_allow: 0
      },
      sound_notification: null
    }
  },
  created () {
    this.checkOAuth()
    this.initData()
  },
  destroyed () {
    clearInterval(this.loop_location)
  },
  mounted () {
    // let platform = navigator.platform
    // this.$modal.show('alert_modal')
  },
  methods: {
    cardGenerator () {
      this.$modal.show('card_modal')
    },
    deviceInfo () {
      this.$modal.show('info_modal')
    },
    // init
    initData () {
      setTimeout(() => {
        if (navigator.geolocation) {
          this.setUser()
          this.getAreaList()
          this.getRecentCheckin()
          this.setLoop()
          this.sound_notification = new Audio('../../static/sound/notification.mp3')
        } else {
          Swal.fire({
            title: 'เกิดข้อผิดพลาดบางอย่าง',
            text: 'ไม่สามารถเข้าถึงตำแหน่งของอุปกรณ์นี้ได้ ลองใหม่อีกครั้ง',
            icon: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ลองใหม่อีกครั้ง',
            showCancelButton: false,
            allowOutsideClick: false
          }).then(result => {
            if (result.isConfirmed) {
              this.reLoad()
            }
          })
        }
      }, 1000)
    },
    // user
    setUser () {
      let jwt = jwt_decode(localStorage.access_token)
      if (jwt !== null) {
        this.user = {
          instructor_id: jwt.instructor_id,
          campus_id: jwt.campus_id,
          fingerprint_id: jwt.fingerprint_id,
          fullname: jwt.fullname,
          card_id: jwt.card_id,
          position: jwt.position,
          image: jwt.image,
          wfh_allow: jwt.wfh_allow
        }
      }
    },
    // area list
    getAreaList () {
      this.$store.state.is_loading = true
      apis.getAreaList(
        this.$store.state.api_url,
        { headers: { 'Access-Token': `${localStorage.access_token}` } },
        result => {
          if (result.response === true) {
            this.area_list = result.data
            this.area_list.forEach(row => {
              row.distance = 0
              row.rad_color = '#f78b83'
            })
            this.getLocation()
          }
          this.$store.state.is_loading = false
        },
        error => {
          this.$store.state.is_loading = false
          console.log(error)
        }
      )
    },
    // recent checkin
    getRecentCheckin () {
      this.$store.state.is_loading = true
      apis.getRecentCheckin(
        this.$store.state.api_url,
        { headers: { 'Access-Token': `${localStorage.access_token}` } },
        result => {
          if (result.response === true) {
            this.recent_checkin = result.data
          }
          this.$store.state.is_loading = false
        },
        error => {
          this.$store.state.is_loading = false
          console.log(error)
        }
      )
    },
    // loop interval
    setLoop () {
      this.loop_location = setInterval(() => {
        this.getLocation()
      }, 3000)
    },
    getLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.calculateAreaDistance)
      }
      let date = new Date()
      // let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      // let second = date.getSeconds()
      if (hour >= 16 && minute >= 30) {
        this.text_checkin = 'ลงเวลาออกงาน'
      } else {
        this.text_checkin = 'ลงเวลาเข้างาน'
      }
    },
    // calculate area distance
    calculateAreaDistance (position) {
      // location
      this.location.lat = parseFloat(position.coords.latitude)
      this.location.long = parseFloat(position.coords.longitude)
      // center
      if (this.center.lat === 0 && this.center.long === 0) {
        this.center.lat = this.location.lat
        this.center.long = this.location.long
      }
      if (this.area_list.length > 0) {
        this.area_list.forEach(row => {
          row.distance = this.calculateDistance(
            {
              lat: this.location.lat,
              long: this.location.long
            },
            {
              lat: row.area_lat,
              long: row.area_long
            }
          )
        })
        this.area_list.sort((a, b) => parseInt(a['distance']) - parseInt(b['distance']))
        this.area_use = this.area_list[0]
        this.checkAreaUse()
      }
    },
    calculateDistance (p1, p2) {
      var R = 6378137
      var calLat = this.calculateRadius(p2.lat - p1.lat)
      var calLong = this.calculateRadius(p2.long - p1.long)
      var a =
        Math.sin(calLat / 2) * Math.sin(calLat / 2) +
        Math.cos(this.calculateRadius(p1.lat)) * Math.cos(this.calculateRadius(p2.lat)) * Math.sin(calLong / 2) * Math.sin(calLong / 2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c
      return Math.ceil(d)
    },
    calculateRadius (x) {
      return (x * Math.PI) / 180
    },
    // check area use
    checkAreaUse () {
      let check = this.calculateInArea(
        {
          lat: this.location.lat,
          long: this.location.long
        },
        {
          lat: this.area_use.area_lat,
          long: this.area_use.area_long,
          rad: this.area_use.area_limit / 1000
        }
      )
      if (check === true) {
        this.area_list.forEach(row => {
          if (row.area_id === this.area_use.area_id) {
            row.rad_color = '#a7f5a4'
            this.area_use_id = this.type === 1 ? this.area_use.area_id : 99
            this.area_use_name = this.type === 1 ? row.area_name : '---'
          } else {
            row.rad_color = '#f78b83'
          }
        })
      } else {
        this.area_use_id = 99
        this.area_use_name = '---'
      }
      this.allowCheckin()
    },
    calculateInArea (p1, p2) {
      var ky = 40000 / 360
      var kx = Math.cos((Math.PI * p2.lat) / 180.0) * ky
      var dx = Math.abs(p2.long - p1.long) * kx
      var dy = Math.abs(p2.lat - p1.lat) * ky
      return Math.sqrt(dx * dx + dy * dy) <= p2.rad
    },
    reCenter () {
      let rand = Math.random() * 0.0000001
      this.center.lat = this.location.lat + rand
      this.center.long = this.location.long + rand
      this.zoom = 15
    },
    reLoad () {
      location.reload()
    },
    // switch type
    switchType () {
      // 1 RMUTL
      // 2 WFH
      if (this.type === 1) {
        if (parseInt(this.user.wfh_allow) === 1) {
          this.type = 2
        } else {
          // this.soundNotification()
          Swal.fire({
            title: 'ฟังก์ชั่นนี้ถูกปิดใช้งาน',
            text: 'ขณะนี้ไม่สามารถปฏิบัติงานที่บ้านได้',
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'รับทราบ',
            showCancelButton: false,
            allowOutsideClick: false
          }).then(result => {
            if (result.isConfirmed) {
            }
          })
        }
      } else {
        this.type = 1
      }
      this.is_allow = false
      this.area_use_id = 99
      this.area_use_name = '---'
      this.checkAreaUse()
    },
    // check allow
    allowCheckin () {
      this.is_allow = false
      if (this.location.lat !== 0 && this.location.long !== 0) {
        if (this.type === 2) {
          this.is_allow = true
        } else {
          if (this.area_use_id !== 99) {
            this.is_allow = true
          }
        }
      }
    },
    checkIn () {
      if (this.is_allow === true) {
        this.$store.state.is_loading = true
        let obj = {
          area_id: this.area_use_id,
          type: this.type,
          lat: this.location.lat,
          long: this.location.long
        }
        apis.addCheckin(
          this.$store.state.api_url,
          obj,
          { headers: { 'Access-Token': `${localStorage.access_token}` } },
          result => {
            if (result.response === true) {
              // this.soundNotification()
              Swal.fire({
                title: 'ทำรายการสำเร็จ',
                text: this.text_checkin + 'เรียบร้อยแล้ว',
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'รับทราบ',
                showCancelButton: false,
                allowOutsideClick: false
              }).then(result => {
                if (result.isConfirmed) {
                  this.getRecentCheckin()
                }
              })
            } else {
              this.unSuccess()
            }
            this.$store.state.is_loading = false
          },
          error => {
            this.$store.state.is_loading = false
            console.log(error)
            this.unSuccess()
          }
        )
      }
    },
    unSuccess () {
      // this.soundNotification()
      Swal.fire({
        title: 'เกิดข้อผิดพลาดบางอย่าง',
        text: 'ข้อมูลเช็คอินไม่ถูกต้อง ลองใหม่อีกครั้ง',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'ลองใหม่อีกครั้ง',
        showCancelButton: false,
        allowOutsideClick: false
      }).then(result => {
        if (result.isConfirmed) {
          this.reLoad()
        }
      })
    },
    soundNotification () {
      if (this.sound_notification) {
        this.sound_notification.play()
        setTimeout(function () {
          this.sound_notification.pause()
          this.sound_notification.currentTime = 0
        }, 1000)
      }
    },
    // check fake location
    async checkFakeLocation () {
      if (navigator.geolocation) {
        this.is_real_location = false
        let location_check = []
        for (let i = 0; i < 5; i++) {
          let position = await this.getFakeLocation(i)
          location_check.push({ lat: position.coords.latitude, long: position.coords.longitude })
        }
        if (location_check.length === 5) {
          let location_check_ = location_check
            .map(JSON.stringify)
            .reverse()
            .filter(function (item, index, arr) {
              return arr.indexOf(item, index + 1) === -1
            })
            .reverse()
            .map(JSON.parse)
          if (location_check_.length > 3) {
            this.is_real_location = true
          }
        }
        if (this.is_real_location === false) {
          Swal.fire({
            title: 'ตรวจพบการปลอมแปลงตำแหน่ง',
            text: 'ปิดใช้งานซอฟต์แวร์ปลอมแปลงตำแหน่ง แล้วลองใหม่อีกครั้ง',
            icon: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ลองใหม่อีกครั้ง',
            showCancelButton: false,
            allowOutsideClick: false
          }).then(result => {
            if (result.isConfirmed) {
              this.reLoad()
            }
          })
        }
      }
    },
    getFakeLocation () {
      let options = {
        enableHighAccuracy: false,
        timeout: 3000,
        maximumAge: 0
      }
      return new Promise((resolve, reject) =>
        setTimeout(() => {
          navigator.geolocation.getCurrentPosition(resolve, reject, options)
        }, 300)
      )
    }
  }
}
</script>

<style lang="css" scoped>
.container {
  margin: 0;
  padding: 0;
  height: 100vh;
  width: 100vw;
}

.top-container {
  position: absolute;
  width: 100vw;
  top: 0;
  padding: 3%;
}

.profile-box {
  width: 100%;
  margin: 0;
  padding: 10px;
  border-radius: 5px;
  background: #ffffff;
  display: flex;
  flex-direction: row;
}

.profile-image {
  margin-right: 10px;
}

.profile-image img {
  object-fit: cover;
  width: 45px;
  height: 45px;
}

.profile-detail {
  flex-grow: 1;
}

.fullname {
  line-height: 1.25;
}

.position {
  line-height: 1.25;
}

.back-btn {
  position: absolute;
  top: 3%;
  left: 3%;
  width: 40px;
  height: 40px;
}

.back-btn i {
  color: #5d6d7e;
}

.bottom-container {
  position: absolute;
  width: 100vw;
  bottom: 0;
  padding: 3%;
}

.action-box {
  margin: 0;
  padding-bottom: 3%;
  text-align: right;
}

.action-btn {
  width: 44px;
  height: 44px;
  margin: 0 !important;
  padding: 0 !important;
  color: #ffffff;
  line-height: 1 !important;
}

.detail-box {
  width: 100%;
  margin: 0;
  padding: 10px;
  border-radius: 5px;
  background: #ffffff;
}

.location-box {
  display: flex;
  flex-direction: row;
}

.location-show {
  flex-grow: 1;
}

.location-switch {
  justify-content: flex-end;
}

.checkin-box {
  margin: 0;
  padding-top: 10px;
  width: 100%;
}

.checkin-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.checkin-list li {
  font-size: 90%;
}

.m-r-5 {
  margin-right: 5px !important;
}

.text-mute {
  color: #727272 !important;
}

.text-left {
  text-align: left !important;
}

.text-center {
  text-align: center !important;
}

.text-right {
  text-align: right !important;
}

.card_container {
  padding: 15px;
  text-align: center;
}

.card_title {
  margin: 0;
  padding: 0;
}

.card_body {
  margin: 0;
  padding: 0;
}

.card_footer {
  margin: 0;
  padding: 0;
}

.m-b-5 {
  margin-bottom: 5px;
}

.m-b-10 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Checkin.vue